import React from "react";
import { Skeleton, Box, Stack } from "@mui/material";

const SkeletonCard = ({ maxWidth }) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: maxWidth,
        bgcolor: "background.paper",
        boxShadow: 1,
        borderRadius: 2,
        p: 2,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="text" width={120} />
      </Stack>

      <Skeleton variant="text" width="80%" sx={{ mt: 2 }} />

      <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: 2 }}>
        <Skeleton variant="text" width={80} />
        <Skeleton variant="text" width={80} />
      </Stack>

      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Skeleton variant="rectangular" width="50%" height={40} />
        <Skeleton variant="rectangular" width="50%" height={40} />
      </Stack>
    </Box>
  );
};

export default SkeletonCard;
